import React from 'react';
import { ClassAssembly4D2026 } from '../views';

const ClassAssemblyPage = () => {
    return <ClassAssembly4D2026/>;
  };
  
  export default ClassAssemblyPage;